"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_aws_CF_URL = void 0;
const SHu_aws_CF_URL = (route) => `https://dyaj6jwzih5dm.cloudfront.net${route}`;
exports.SHu_aws_CF_URL = SHu_aws_CF_URL;
